import { render, staticRenderFns } from "./list-article.vue?vue&type=template&id=17f47830&scoped=true"
import script from "./list-article.vue?vue&type=script&lang=js"
export * from "./list-article.vue?vue&type=script&lang=js"
import style0 from "./list-article.vue?vue&type=style&index=0&id=17f47830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f47830",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnReadmore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-readmore.vue').default})
